module.exports = __webpack_public_path__ + "static/media/colorWhite.4b58ee07.png";